import axios from "axios";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { PO_API } from "../CreatePurchaseOrder/data";
import { ginesysSyncTone, poStatusTone } from "../CreatePurchaseOrder/poUi";

export const lsPoFilterValStr = "purchase_order_filter_obj";

export const poStatusOptions = Object.keys(poStatusTone).map((key) => ({ key, name: key }));

export const ginesysSyncOptions = Object.keys(ginesysSyncTone).map((key) => ({ key, name: key }));

export const entryModeFilterOptions = [
	{ key: "I", name: "Item (I)" },
	{ key: "S", name: "Set (S)" },
];

export const boolFilterOptions = [
	{ key: true, name: "Yes" },
	{ key: false, name: "No" },
];

const enterColumn = (name, key, dataType = datatypes.STRING.key) => ({
	name,
	key,
	input_type: inputTypes.ENTER.key,
	data_type: dataType,
	editable: true,
	constraints: { DISPLAY: true },
});

const selectColumn = (name, key, list) => ({
	name,
	key,
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	editable: true,
	constraints: { DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list,
	},
});

export const poListColumnsObj = {
	id: enterColumn("ID", "id", datatypes.NUMBER.key),
	po_no: enterColumn("PO No", "po_no"),
	status: selectColumn("Status", "status", poStatusOptions),
	vendor_code: enterColumn("Vendor", "vendor_code", datatypes.NUMBER.key),
	owner_site_code: enterColumn("Owner Site", "owner_site_code", datatypes.NUMBER.key),
	order_date: enterColumn("Order Date", "order_date", datatypes.DATE.key),
	entry_mode: selectColumn("Entry Mode", "entry_mode", entryModeFilterOptions),
	doc_code: enterColumn("Doc Scheme", "doc_code", datatypes.NUMBER.key),
	trade_group_code: enterColumn("Trade Group", "trade_group_code", datatypes.NUMBER.key),
	purchase_term_code: enterColumn("Purchase Term", "purchase_term_code", datatypes.NUMBER.key),
	ginesys_po_id: enterColumn("Ginesys PO Id", "ginesys_po_id", datatypes.NUMBER.key),
	ginesys_scheme_doc_no: enterColumn("Ginesys Scheme Doc No", "ginesys_scheme_doc_no"),
	ginesys_sync: selectColumn("Ginesys Sync", "ginesys_sync", ginesysSyncOptions),
	is_consignment: selectColumn("Consignment", "is_consignment", boolFilterOptions),
	is_authorized: selectColumn("Authorized", "is_authorized", boolFilterOptions),
	created_by: enterColumn("Created By", "created_by"),
	last_updated_by: enterColumn("Last Updated By", "last_updated_by"),
	published_by: enterColumn("Published By", "published_by"),
};

export const poListTableColumns = [
	poListColumnsObj.id,
	poListColumnsObj.po_no,
	poListColumnsObj.status,
	poListColumnsObj.vendor_code,
	poListColumnsObj.owner_site_code,
	poListColumnsObj.order_date,
	poListColumnsObj.entry_mode,
	poListColumnsObj.ginesys_scheme_doc_no,
	poListColumnsObj.ginesys_po_id,
	poListColumnsObj.ginesys_sync,
	poListColumnsObj.is_authorized,
	poListColumnsObj.created_by,
	poListColumnsObj.last_updated_by,
	poListColumnsObj.published_by,
].map((col) => ({
	...col,
	align: "center",
	headerAlign: "center",
	minWidth:
		col.key === "last_updated_by" || col.key === "published_by"
			? 200
			: col.key === "po_no" || col.key === "ginesys_scheme_doc_no"
				? 160
				: 110,
}));

/** More Filters modal columns (PO No + Scheme Doc No are quick-search fields on the grid toolbar). */
export const getPoFilterColumns = () => [
	poListColumnsObj.status,
	poListColumnsObj.vendor_code,
	poListColumnsObj.owner_site_code,
	poListColumnsObj.entry_mode,
	poListColumnsObj.ginesys_po_id,
	poListColumnsObj.doc_code,
	poListColumnsObj.ginesys_sync,
	poListColumnsObj.is_consignment,
	poListColumnsObj.is_authorized,
	poListColumnsObj.created_by,
	poListColumnsObj.published_by,
];

export const listPurchaseOrdersApi = async ({ limit, offset, filter }) => {
	const res = await axios.post(`${PO_API}/list`, { limit, offset, filter });
	return res.data?.result || { rows: [], total_rows_count: 0 };
};
